// FormList.js
import React, { useEffect, useState } from 'react';
import { deleteForm,deleteConsentForms,deleteNonConsentForms } from './api';


const FormList = ({ consentforms,setConsentForms,nonConsentforms, setNonConsentForms, editForm, settempForms, posttoDatabase,
  fetchFormData }) => {

  const [editingForm, setEditingForm] = useState(null);
  const [editingElement, setEditingElement] = useState(null);


const removeForm=async (id)=>{
 await deleteForm(id);
 fetchFormData();
}

  async function removeAll(a){
  if(a==1){
    await deleteConsentForms();
  }
  else{
    await deleteNonConsentForms();
  }
}


  // Placeholder for rendering logic of form elements
  const renderFormElement = (element) => {
    switch (element.elementType) {
      case 'Text Field':
        return (<input type="text" placeholder={element.placeholder} />

        );
      case 'Checkbox':
        return (
          <div>
            {element.options.map((option, index) => (
              <div key={index}>
                <input type="checkbox" id={`checkbox-${index}`} />
                <label htmlFor={`checkbox-${index}`}>{option}</label>
              </div>
            ))}
          </div>
        );
      case 'Radio Button':
        return (
          <div>
            {element.options.map((option, index) => (
              <div key={index}>
                <input type="radio" id={`radio-${index}`} name={`radio-group-${element.formId}`} />
                <label htmlFor={`radio-${index}`}>{option}</label>
              </div>
            ))}
          </div>
        );
      case 'Dropdown':
        return (
          <select>
            {element.options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case 'Date Picker':
        return (
          <>
            <input type="date" name={element.selectedOption} />
          </>
        );

      case 'Textarea':
        return (
          <textarea placeholder={`Enter ${element.name}`} name={element.selectedOption}></textarea>

        );


      default:
        return null;
    }
  };

  return (
    <div class="max-width rightSide">
      <div className='formListWrap'>
      {nonConsentforms?.length > 0 && (
        <>
          <div class="forms-list-header">
          <h2>NonConsent Forms</h2>
         { <button className='button' onClick={() => removeAll(2)}>
            Remove All
      </button>}
          </div>
          {nonConsentforms?.map((form) => (
            <div key={form.id} className="form-container form-list">
              <h3>Form {form.name}</h3>
              <button className='button' onClick={() => editForm(form.id)}>Edit Form</button>
              <button className='button' onClick={() => removeForm(form.id)}>
                Remove Form
          </button>
            </div>
          ))}
         
       

         
        </>
      )}
      </div>
       {consentforms?.length > 0 && (
        <>
          <div class="forms-list-header">
          <h2>Consent Forms</h2>
          <button className='button' onClick={() => removeAll(1)}>
            Remove All
       </button>
          </div>
          {consentforms?.map((form) => (
            <div key={form.id} className="form-container form-list">
              <h3>Form {form.name}</h3>
              <button className='button' onClick={() => editForm(form.id)}>Edit Form</button>
              <button className='button' onClick={() => removeForm(form.id)}>
                Remove Form
          </button>
            </div>
          ))}
         
       

         
        </>
      )}
    </div>
  );
};

export default FormList;
